import { Card, Col, Row } from 'react-bootstrap';
import TextLoading from '@/app/common/components/skeleton/TextLoading';

const AuthPreload = () => (
  <div className="container-fluid py-3" aria-busy="true" aria-label="در حال بارگذاری">
    <div className="d-flex justify-content-between align-items-center mb-4">
      <div>
        <TextLoading width={180} height={18} isWidthPx />
        <div className="mt-2">
          <TextLoading width={260} height={10} isWidthPx />
        </div>
      </div>
      <TextLoading width={90} height={32} isWidthPx />
    </div>
    <Row className="g-3">
      {[1, 2, 3].map(item => (
        <Col key={item} xs={12} md={4}>
          <Card className="h-100">
            <Card.Body>
              <TextLoading width="45%" height={14} />
              <div className="mt-4">
                <TextLoading width="70%" height={24} />
              </div>
              <div className="mt-3">
                <TextLoading width="100%" height={8} />
              </div>
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
    <Card className="mt-3">
      <Card.Body>
        <TextLoading width="30%" height={14} />
        <div className="mt-4">
          {[1, 2, 3, 4].map(item => (
            <div className="mb-3" key={item}>
              <TextLoading width={`${55 + item * 7}%`} height={10} />
            </div>
          ))}
        </div>
      </Card.Body>
    </Card>
  </div>
);

export default AuthPreload;
